import React from "react";

const GcpGroups = () => {
  return <div></div>;
};

export default GcpGroups;
